import { Logger } from 'src/utils/Logger';
import { EventAction } from './types';
import { getEventData } from './getEventData';

export const publishEvent = (event: EventAction): void => {
  try {
    const publishCdmEvents = window?.Shell?.v1?.analytics?.publishCdmEvents;

    if (!event || !publishCdmEvents) {
      Logger.error('Invalid event or publishCdmEvents is not available');
      return;
    }

    const payload = getEventData(event);
    const cdmEvents = {
      dateTime: new Date().toISOString(),
      eventDetailType:
        'com.hp.cdm.domain.telemetry.type.eventDetail.category.simpleUi.version.1',
      eventCategory: 'simpleUi',
      eventDetail: payload,
      version: '1.4.0'
    };
    publishCdmEvents([cdmEvents]);
    Logger.log('Event published successfully:', cdmEvents);
  } catch (error) {
    Logger.log('Failed to publish event:', error);
  }
};
